import { LifeSkillsMonitoringNonStandardReason } from 'api';

export const getLifeSkillsMonitoringNonStandardReasonName = (
  reasonType: LifeSkillsMonitoringNonStandardReason
): string => {
  const reasonTypeNames: Record<LifeSkillsMonitoringNonStandardReason, string> = {
    [LifeSkillsMonitoringNonStandardReason.Ratings]: 'Ratings',
    [LifeSkillsMonitoringNonStandardReason.Procedures]: 'Procedures',
    [LifeSkillsMonitoringNonStandardReason.BothRatingAndProcedures]: 'Both Rating and Procedures',
  };
  return reasonTypeNames[reasonType] ?? '-';
};
